import { useState } from 'react';
import axios from 'axios';
import { useDispatch } from 'react-redux';
import { PencilIcon, CheckIcon, XIcon } from '@heroicons/react/solid';
import { setAlert } from 'features/alerts/alertsSlice';
import { numberFormatter } from 'utils/formatters';
import classNames from 'utils/classNames';

const AllocationEditor = ({
  entityId,
  currentValue,
  editable = false,
  attribute,
}) => {
  const dispatch = useDispatch();

  const [editing, setEditing] = useState(false);
  const [value, setValue] = useState(currentValue);
  const [saving, setSaving] = useState(false);

  const updateValue = () => {
    if (saving) return;

    setSaving(true);
    axios
      .put(`/account/products/inventory/items/${entityId}`, {
        [attribute]: value,
      })
      .then((response) => {
        dispatch(setAlert('success', response.data.message));
        setValue(response.data.data[0][attribute]);
      })
      .catch((error) => {
        setValue(currentValue);
        dispatch(setAlert('error', error.response.data.message));
      })
      .finally(() => {
        setSaving(false);
        setEditing(false);
      });
  };

  const exitEditing = () => {
    if (saving) return;
    setValue(currentValue);
    setEditing(false);
  };

  return (
    <div className="flex justify-center">
      {editing ? (
        <div className="flex items-center">
          <div className="relative rounded-2xl">
            <input
              type="number"
              className="pr-3 pl-8 py-1.25 border text-grayscale-800 focus:outline-none focus:ring-0 focus:border-gray-300 block w-full text-mini border-gray-300 rounded-3xl outline-none appearance-none focus:appearance-none focus:outline-none focus:ring-0"
              value={value}
              onChange={(e) => setValue(e.target.value)}
              disabled={saving}
            />
          </div>
          <div className="flex ml-2">
            <CheckIcon
              className={classNames(
                'h-5 w-5 text-secondary',
                saving ? 'cursor-wait' : 'cursor-pointer'
              )}
              onClick={updateValue}
            />
            <XIcon
              className={classNames(
                'h-5 w-5 text-secondary',
                saving ? 'cursor-wait' : 'cursor-pointer'
              )}
              onClick={exitEditing}
            />
          </div>
        </div>
      ) : (
        <div className="flex items-center">
          <div className="flex flex-col">
            <span className="text-mini">{numberFormatter(value)}</span>
          </div>
          {editable && (
            <PencilIcon
              className="ml-3 h-5 w-5 cursor-pointer text-secondary"
              onClick={() => setEditing(true)}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default AllocationEditor;
